import styled from "@emotion/styled";
import {
  DropdownField,
  Grid,
  GridColumn,
  Grids,
  Heading,
  MediaQueries,
  Spacer,
  Spacings,
} from "@polestar/component-warehouse-react";
import { Form, useSubmit } from "@remix-run/react";

const StyledGridColumn = styled(GridColumn)`
  grid-column: span ${Grids.desktop.columns};
  // need to do calc here as dropdown field already has
  // 4px margin, we can't get the 64px margin otherwise.
  margin-bottom: calc(${Spacings.xxLarge} + ${Spacings.small});

  ${MediaQueries.tablet} {
    grid-column: span 3;
  }

  ${MediaQueries.desktop} {
    grid-column: span 2;
    margin-bottom: ${Spacings.xxxxLarge};
  }
`;

interface Props {
  readonly title: string;
  readonly newsTagId?: string;
  readonly newsTags: Array<{ id: string; tag: string }>;
  readonly dropdownLabel: string;
  readonly defaultOptionLabel: string;
}
const Filter = ({
  title,
  newsTagId,
  newsTags,
  dropdownLabel,
  defaultOptionLabel,
}: Props) => {
  const submit = useSubmit();

  const dropdownOptions = newsTags.map(({ id, tag }) => {
    return {
      value: id,
      label: tag,
    };
  });

  dropdownOptions.unshift({
    value: "",
    label: defaultOptionLabel,
  });

  return (
    <Grid>
      <GridColumn span={{ mobile: 4, tablet: 3, desktop: 4 }}>
        <Heading level={1}>{title}</Heading>
        <Spacer spacing={{ mobile: Spacings.xLarge, tablet: "0" }} />
      </GridColumn>
      <GridColumn span={{ mobile: 4, tablet: 5, desktop: 4 }}>
        <StyledGridColumn
          span={{
            mobile: 4,
            tablet: 3,
            desktop: 3,
            desktopWide: 2,
          }}
        >
          <Form method="get">
            <DropdownField
              label={dropdownLabel}
              value={newsTagId}
              options={dropdownOptions}
              placeholder={defaultOptionLabel}
              onChange={(id) => {
                submit(new URLSearchParams(id ? { tag: String(id) } : {}));
              }}
            />
          </Form>
        </StyledGridColumn>
      </GridColumn>
    </Grid>
  );
};

export default Filter;
